<div class="kds-Card review-cards p-24">
  <div class="flex flex-col items-center justify-center">
    <img
      *ngIf="reviewType == 'branch'"
      src="../../../../assets/icons/groceries.svg"
      alt="kds accent icon ship success"
    />
    <img
      *ngIf="reviewType == 'item'"
      src="../../../../assets/icons/recurringPurchase.svg"
      alt="kds accent icon ship success"
    />
    <img
      *ngIf="reviewType == 'Facility'"
      src="../../../../assets/icons/kds-accent-icon-pickup-success.svg"
      alt="kds accent icon pickup success"
    />
    <div class="flex flex-col items-center my-16 lh-20">
      <p class="heading-m nunito-regular-font mb-8">
        {{ reviewType | titlecase }} Review
      </p>
      <p class="body-m roboto-regular-font">{{ discriptionOne }}</p>
      <p class="body-m roboto-regular-font">{{ discriptionTwo }}</p>
    </div>
    <kds-button kind="primary" [routerLink]="navigationLink">{{
      buttonText
    }}</kds-button>
    <kds-button
      *ngIf="reviewType == 'item'"
      kind="tertiary"
      class="mt-4"
      [routerLink]="'../search-gtin'"
    >
      <kds-icon-search size="s" class="mr-4"></kds-icon-search>
      Search by GTIN
    </kds-button>
  </div>
  <div
    class="disable-card absolute pin-t pin-l w-full h-full flex justify-center items-center rounded-medium"
    *ngIf="disable"
  ></div>
</div>
